import { render, staticRenderFns } from "./continuationPreservationDetail.vue?vue&type=template&id=43378bd0&scoped=true&"
import script from "./continuationPreservationDetail.vue?vue&type=script&lang=js&"
export * from "./continuationPreservationDetail.vue?vue&type=script&lang=js&"
import style0 from "./continuationPreservationDetail.vue?vue&type=style&index=0&id=43378bd0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43378bd0",
  null
  
)

export default component.exports